/* Попап кнопки аккаунта. Тот же приём, что у истории снимков
   (sync/SnapshotControls.module.css): якорь на обёртке кнопки, сам попап —
   absolute под ней. */

.menu {
  position: absolute;
  top: calc(100% + var(--sp-2));
  right: 0;
  z-index: 40;
  display: flex;
  flex-direction: column;
  width: 260px;
  padding: var(--sp-2);
  background: var(--surface);
  border: var(--bw) solid var(--border-strong);
  border-radius: var(--radius-lg);
  -webkit-backdrop-filter: var(--glass-blur);
  backdrop-filter: var(--glass-blur);
  box-shadow: var(--glass-rim), var(--shadow-lift);
}

/* Развёрнутый вид внутри бургера: рамка, тень и своя ширина здесь лишние —
   их даёт сама панель, а второй слой поверх неё читается как сбой. */
.inline {
  position: static;
  width: 100%;
  padding: 0;
  background: none;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-4);
  min-height: 40px;
  padding: var(--sp-2) var(--sp-3);
}

.rowLabel {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-height: 40px;
  padding: var(--sp-2) var(--sp-3);
  background: none;
  border: none;
  border-radius: var(--radius);
  color: var(--text);
  font: inherit;
  font-size: var(--fs-sm);
  text-align: left;
  cursor: pointer;
}

.item:hover {
  background: var(--surface-2);
}

.item:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring);
}

/* Первая строка пункта: название (+ счётчик у «Поездок»). */
.itemMain {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-3);
  width: 100%;
}

/* Иконка + подпись — общая группа для каждого пункта (B6): у «Поездок» рядом
   с ней ещё и счётчик в itemMain, у остальных пунктов группа там одна и
   занимает всю строку сама, без второго child — на итоговой раскладке это
   никак не сказывается, justify-content: space-between у itemMain работает
   одинаково что с одним, что с двумя элементами. */
.itemLabel {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  min-width: 0;
}

.itemLabel svg {
  flex: none;
}

.itemCount {
  color: var(--text-3);
  font-size: var(--fs-xs);
}

/* Вторая строка — постоянная подсказка «что дальше»: title не всплывает от
   касания, а меню целиком живёт и в мобильном бургере, где мыши нет вовсе. */
.itemHint {
  color: var(--text-3);
  font-size: var(--fs-xs);
  line-height: 1.3;
}

/* Последний пункт меню — действие с сеансом, а не настройка вида: «Выйти» у
   вошедшего, «Войти» у гостя. Волосок сверху отделяет его от остального
   списка; класс общий на оба, чтобы вход и выход не разъехались по виду. */
.action {
  margin-top: var(--sp-2);
  padding-top: calc(var(--sp-2) + var(--sp-3));
  border-top: var(--bw) solid var(--border);
}

/* ── Телефон (порог продублирован в ui/shell/useIsMobile.ts) ─────────────── */
@media (max-width: 720px) {
  /* Внутри бургер-меню absolute-попап привязан к раю его прокрутки и легко
     обрезается — та же проблема решена так же, как в SnapshotControls:
     попап переезжает нижней шторкой, привязанной к экрану, а не к кнопке. */
  .menu {
    position: fixed;
    inset: auto var(--sp-4) var(--sp-4) var(--sp-4);
    z-index: 1100;
    width: auto;
    max-height: 70vh;
    overflow-y: auto;
  }

  /* Шторка — только для попапа под кнопкой. Развёрнутый вид уже стоит
     внутри бургера и никуда не всплывает: там он обычный блок в потоке, иначе
     уехал бы к низу экрана мимо панели, в которой живёт. */
  .inline {
    position: static;
    inset: auto;
    z-index: auto;
    width: 100%;
    max-height: none;
    overflow: visible;
  }

  /* Пальцем, а не курсором: строки выше, чем в попапе под кнопкой. */
  .row,
  .item {
    min-height: 52px;
  }

  /* Каждый пункт отбит волоском сверху. В попапе под кнопкой список короткий и
     разделители были бы шумом, а в развёрнутом виде пунктов много, у половины
     из них по две строки текста — без линеек они сливаются в сплошное полотно,
     и глазом не поймать, где кончается один пункт и начинается следующий. */
  .inline .row,
  .inline .item {
    border-top: 1px solid var(--border);
    border-radius: 0;
  }

  /* Вход/выход и так отбиты своим волоском — второй сверху дал бы двойную. */
  .inline .action {
    margin-top: 0;
    padding-top: var(--sp-4);
  }
}
